var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuroMoyen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154,
    height: 148,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M139.5 73.876c-.353 39.599-21.59 71.788-59.199 72.524l-10.743-.095C31.154 145.964.29 113.178.648 73.045 1.008 32.775 32.183.407 70.589.614c.94.009 9.266.083 10.206.09 37.05 1.668 59.056 33.84 58.706 73.037l-.001.134Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M82.446 147.09c38.405.341 69.716-32.026 70.075-72.294.359-40.268-30.503-73.187-68.774-73.527-38.27-.34-69.715 32.026-70.074 72.294-.36 40.268 30.503 73.187 68.773 73.527Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M82.46 145.215c37.331.332 67.963-31.239 68.313-70.436.349-39.198-29.714-71.307-67.045-71.639-37.33-.331-67.962 31.239-68.312 70.437-.35 39.197 29.714 71.307 67.045 71.638Z",
    opacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M82.485 143.074c36.256.322 65.938-30.186 66.279-68.314.34-38.127-28.794-69.158-65.05-69.48-36.257-.322-65.939 30.187-66.28 68.314-.34 38.128 28.794 69.159 65.05 69.48Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M81.153 141.592c35.45.315 64.591-29.663 64.922-66.854.332-37.191-28.135-67.68-63.72-67.997-35.585-.316-64.59 29.663-64.923 66.854-.331 37.191 28.136 67.681 63.72 67.997Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "m110.149 97.294 2.042 11.926c-7.15 3.683-16.442 6.543-26.245 6.456C64.462 115.486 51.672 104 47.8 86.439l-12.622-.112 3.154-7.33 8.46.074c-.12-1.606-.238-3.48-.222-5.22.012-1.337.023-2.675.168-3.878l-9.936-.088 3.153-7.197 8.056.072c4.593-18.021 19.742-30.196 39.75-30.018 9.132.081 17.84 2.433 24.926 5.974l-2.528 12.42-.672-.006c-6.539-4.607-13.771-6.811-21.56-6.88-12.085-.108-20.206 7.045-23.399 18.656l36.525.325-2.884 7.199-34.914-.31c-.145 1.203-.157 2.54-.169 3.878-.015 1.74.102 3.613.222 5.22l32.228.286-2.75 7.334-28.335-.251c2.724 10.86 9.916 17.481 22.673 17.594 6.983.062 15.195-2.14 22.219-6.76l.671.006.136-.133Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDD89",
    d: "M65.25 72.132c-4.822-16.5 13.144-28.248 10.496-47.537-1.133-8.44-5.905-15.439-11.763-21.11-28.01 8.716-48.538 36.63-48.835 69.942-.361 40.401 29.56 73.312 66.489 73.506 9.13.081 17.743-1.85 25.697-5.392-.999-23.422-7.73-36.593-14.91-44.684-11.17-12.275-23.526-12.25-27.173-24.86l-.001.135Z",
    opacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 272.747,
    x2: -53.766,
    y1: 130.984,
    y2: 36.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC9E5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C6D13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 112.351,
    x2: -28.305,
    y1: 31.492,
    y2: 238.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5C680"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 118.984,
    x2: 76.909,
    y1: 25.261,
    y2: 83.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0BE71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5C57E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 40.491,
    x2: 101.83,
    y1: -42.064,
    y2: 126.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D29918"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -0.466,
    x2: 127.53,
    y1: 288.573,
    y2: -47.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 35.557,
    x2: 112.636,
    y1: 73.754,
    y2: 74.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEFB6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuroMoyen);
export default __webpack_public_path__ + "static/media/euroMoyen.ff3261aa75771d5a614da051a5ae0ac6.svg";
export { ForwardRef as ReactComponent };